module.exports = "<section class=\"ui-card margin-md\">\r\n  <header class=\"kd-item kd-item--large padding-md\">\r\n    <h1 class=\"typo-title nobreak flex\">{{::$ctrl.empresa}}</h1>\r\n  </header>\r\n  <prestamos-externos-lista-prestamo\r\n      ng-repeat=\"item in $ctrl.prestamos track by item.descuento.id\"\r\n      data=\"item\"></prestamos-externos-lista-prestamo>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/prestamosExternos/components/lista/empresa/template.html
// module id = 811
// module chunks = 0